module.exports = __webpack_public_path__ + "img/p3.2903ce9a.png";